import router from "@/router"
import store from "@/store"
import { closeWebView } from "./appInteraction"

const navigation = {
    //跳转授权页面
    goAuth: ()=> {
        store.commit("setToken",null);
        this.replace({path:"/Auth",query:{goUrl:router.history.current.fullPath}});
    },
    //跳转不保留当前页面
    replace: parameters=> {
        router.replace(parameters);
        store.commit("setAkipWay",'replace');
    },
    //跳转
    go: parameters=> {
        router.push(parameters);
        store.commit("setAkipWay",'go');
        pagelength(true);
    },
    //后退
    back: ()=> {
        var length = pagelength();
        if(length <= 0 || window.history.length == 1){
            closeWebView();
        } else {
            router.back();
            store.commit("setAkipWay",'back');
        }
    }
};
//记录当前打开的页面数量
const pagelength = function(isAdd) {
    var length = parseInt(sessionStorage.getItem("pagelength"));
    if(isAdd){
        length++;
    }else{
        length--;
    }
    sessionStorage.setItem("pagelength",length);
    return length;
}
export default navigation;
